export default (theme: Object) => ({
  dropzone: {
    boxSizing: 'border-box',
    backgroundColor: '#FFFFFF',
    color: theme.palette.neutrals.mainText,
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 22,
    fontWeight: 600,
    cursor: 'pointer',
    paddingBottom: 40,
    minHeight: 262,
  },
  otherDetails: {
    fontSize: 14,
    fontWeight: 400,
  },
  iconSmall: {
    height: 20,
    width: 20,
    margin: '0px',
    padding: '0 8px',
    color: theme.palette.neutrals.mainText,
  },
  checkIcon: {
    height: 28,
    width: 28,
    marginRight: '14px',
    minWidth: 28,
    minHeight: 28,
    color: theme.palette.neutrals.greenIcon,
  },
  dropzoneContainer: {
    minHeight: 262,
    width: '100%',
    display: 'flex',
    flexFlow: 'column',
    position: 'relative',
  },
  paddingAnimationDropzone: {
    paddingBottom: 10,
    transition: 'all 1s ease',
  },
  paddingAnimationDropzoneOff: {
    paddingBottom: 40,
    transition: 'all 1s ease',
  },
  warningButton: {
    borderRadius: 0,
    textTransform: 'none',
    padding: '8px 0',
    minWidth: 20,
  },
  uploadListContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '18px',
  },
  rejectedListContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: '18px',
  },
  rejectedList: {
    display: 'flex',
    alignItems: 'center',
  },
  errorIcon: {
    height: 28,
    width: 28,
    marginRight: '14px',
    minWidth: 28,
    minHeight: 28,
    color: theme.palette.semantic.error,
  },
  removeButton: {
    borderRadius: 0,
    textTransform: 'none',
    padding: '8px 0',
    minWidth: 20,
    '&:hover': {
      cursor: 'pointer',
    },
  },
  documentName: {
    fontSize: '15px',
    color: theme.palette.neutrals.mainText,
    width: '80%',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
  },
  errorText: {
    fontSize: '15px',
    fontWeight: '600',
    color: theme.palette.semantic.error,
  },
  dragOver: {
    opacity: 0.90,
  },
  processing: {
    margin: '0 10px',
  },
  tooltip: {
    overflow: 'hidden',
    backgroundColor: theme.palette.primary.main,
    minWidth: 'fit-content',
    overflowWrap: 'break-word',
    wordBreak: 'break-all',
    display: 'flex',
    alignSelf: 'center',
    alignItems: 'center',
    justifyContent: 'center',
  },
  hide: {
    display: 'none',
  },
});
